export const LOAD_TIMEOUT = 10000;
export const RETRY_DELAY = 1000;
export const MAX_RETRIES = 3;

export const getTopolOptions = ({ onSave, onInit, onError }) => ({
    id: '#topol-app',
    authorize: {
        apiKey: 'YN06EwYAdm0TrwOMNsZ5UnsM4vq1T1mnAOuZMSLpcsUxhOoLzUElMA0Kw6ht',
        userId: 'UserID',
    },
    callbacks: {
        onSave,
        onInit,
        onError,
    },
    savedBlocks: [],
    title: '',
    syncedSectionsEnabled: true,
    mergeTags: [
        {
            name: 'Contact',
            items: [
                {
                    value: '*|FIRST_NAME|*',
                    text: 'First name',
                    label: "Customer's first name",
                },
                {
                    value: '*|LAST_NAME|*',
                    text: 'Last name',
                    label: "Customer's last name",
                },
            ],
        },
        {
            name: 'Company',
            items: [
                {
                    value: '*|COMPANY_NAME|*',
                    text: 'Company name',
                    label: "Company's name",
                },
            ],
        },
    ],
    topBarOptions: [
        'undoRedo',
        'save',
        'changePreview',
        'previewSize',
        'previewTestMail',
        'changeLanguage',
    ],
    theme: {
        preset: 'light',
        colors: {
            900: '#fff',
            800: '#F1F1F2',
            700: '#EBEBEC',
            600: '#DFDFE0',
            500: '#D7D8D9',
            400: '#C9CACB',
            300: '#A4A5A7',
            200: '#8D8F92',
            100: '#727477',
            50: '#4B4C4E',
            10: '#2B2B2C',
            white: '#ffffff',
            primary: '#9D82FF',
            'primary-light': '#B4A0FF',
            'primary-light-2': '#DFD9FF',
            secondary: '#11CFC4',
            'secondary-light': '#00E5D8',
            'secondary-light-2': '#CEFAF8',
            error: '#C4261A',
            'error-light': '#E32F22',
            success: '#11BA5C',
            'success-light': '#0CDB68',
            active: '#35AAFF',
            'active-2': '#0FCE56',
            'active-3': '#FF9900',
        },
    },
    textOverride: {
        'blocks.premade_content': 'Components',
    },
    customBlocks: [
        {
            key: 'custom-block-key',
            name: 'Bocked component',
            dialog: true,
            icon: 'box',
            content: '<p>Componente bloqueado que no se puede editar</p>',
            dialogButtonText: 'Open Custom Dialog',
            disabled: false,
        },
    ],
});
